import { Footer } from './Footer';
import { InfoBlock as InfoBlockComponent } from './InfoBlock';
// eslint-disable-next-line import/export
export const InfoBlock = InfoBlockComponent;
InfoBlock.Footer = Footer;
